import { ReservationSearchCriteria } from '../criteria/reservation-search-criteria';
import { ServiceNote } from './service-note';

export class NoteWrapper {
    serviceItemSearchCriteria :  ReservationSearchCriteria;
    serviceNotes : ServiceNote[] = [];
}
